import React, { Suspense } from 'react';
import { CrewMember } from '@bechtel/types';
import { ErrorBoundary, UnderConstruction, SuspenseLoader, CacheKeys, useSessionStorage } from '@bechtel/client-common';
import { DashboardHeader } from '~/header';
import { DashboardPersonaContainerStyled } from '~/styled';
import { useDashboardPermissions, UserSelector } from '@bechtel/client-dashboard-common';
import { DashboardContainerStyled } from './styled';
import { DashboardContent } from '~/content';

const DashboardView = () => {
  const [selectedCrewMember, setSelectedCrewMember] = useSessionStorage<CrewMember | null>(
    CacheKeys.DashboardSelectedUser,
    null
  );
  //All the dashboard default canView properties are mutually exclusive only one or none will be true at a time
  const { canViewOtherUserDashboard, hasNoDefaultDashboard } = useDashboardPermissions();
  return (
    <DashboardContainerStyled>
      {hasNoDefaultDashboard ? (
        <UnderConstruction />
      ) : (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <DashboardPersonaContainerStyled>
              <DashboardHeader />
              {canViewOtherUserDashboard && (
                <UserSelector selectedCrewMember={selectedCrewMember} setSelectedCrewMember={setSelectedCrewMember} />
              )}
              <DashboardContent selectedCrewMember={selectedCrewMember} />
            </DashboardPersonaContainerStyled>
          </Suspense>
        </ErrorBoundary>
      )}
    </DashboardContainerStyled>
  );
};

export default DashboardView;
